<template>
  <v-btn
    fab
    small
    depressed
    :color="value ? 'primary' : 'secondary'"
    style="margin-left: -8px;"
    @click="toggle()"
  >
    <v-icon v-text="icon" />
  </v-btn>
</template>

<script>
  import Lockable from '@/Mixins/Lockable'
  import UsesIcons from '@/Mixins/UsesIcons'

  export default {
    mixins: [
      Lockable,
      UsesIcons,
    ],

    props: {
      value: {
        required: true,
        type: Boolean,
      },
    },

    computed: {
      icon () {
        return this.icons[this.value ? 'searchClose' : 'search']
      },
    },

    methods: {
      toggle () {
        if (this.locked) {
          return
        }
        this.lock(400)
        this.$store.commit('catalog/needle', '')
        this.$emit('input', ! this.value)
      },
    },
  }
</script>
